(ns frontend.ui.component.lp-portal.voima-components.text-content.view
  (:require
   [common.localization :as loc]
   [common.time :as c-time]
   [common.util :as cu]
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.lp-portal.voima-components.text-content.style :as style]
   [frontend.utils :as fu]
   [herb.core :refer [<class] :as h]
   [reagent.core :as r]
   [ui.components.button.view :as button]
   [ui.components.rich-text.tiptap :as tiptap]))

#_(defn rich-text-content
  [{:keys [html-content completed-at _complete-changed! show-draft? edit-text-label _can-edit?
           _on-change background-color?
           toolbar]}]
  (let [local-state (r/atom {:draft? (cu/blank-value? completed-at)})
        editor-state (rich/init-state html-content)]
    (fn [{:keys [_html-content completed-at complete-changed! can-edit? on-change]}]
      (let [edit-mode? (:edit-mode? @local-state)
            local-draft? (:draft? @local-state)
            draft? (if (boolean? local-draft?)
                     local-draft?
                     (cu/blank-value? completed-at))]
        [:div
         {:class (h/<class (partial style/text-container (and draft? show-draft?) background-color?))}
         (when (and draft? show-draft?)
           [:div
            {:class (h/<class style/draft-indicator)}
            (loc/tr :draft)])
         [:div
          (cond
            (not can-edit?)
            [rich-text-editor/rich-text-editor
             {:read-only? true
              :border?    edit-mode?} editor-state]

            edit-mode?
            [:div
             [rich-text-editor/rich-text-editor
              {:toolbar (or toolbar
                            rich-text-editor/no-align-toolbar-options)
               :border? edit-mode?}
              editor-state]
             [button/primary-solid
              {:on-click (fn [_e]
                           (let [content-state ^js (.getCurrentContent @editor-state)
                                 new-html-content (js->clj (stateToHTML content-state))]
                             (on-change new-html-content)
                             (swap! local-state dissoc :edit-mode?)))}
              (loc/tr :save)]
             [:label
              {:class (h/<class style/complete-label)}
              [:input
               {:type      "checkbox"
                :checked   (not draft?)
                :on-change (fn [_i]
                             (let [content-state ^js (.getCurrentContent @editor-state)
                                   new-html-content (js->clj (stateToHTML content-state))]
                               (swap! local-state assoc :draft? (not draft?))
                               (complete-changed! new-html-content (not draft?))
                               (when draft?
                                 (swap! local-state dissoc :edit-mode?))))}]
              [:span
               {:class (h/<class style/complete-label-text)}
               (loc/tr :lp-editor-text-complete-label)]]]

            :else
            [:div
             [:span
              {:class    (<class style/edit-text)
               :on-click (fn [e]
                           (fu/stop-propagation-event! e)
                           (swap! local-state assoc :edit-mode? true))}
              (or edit-text-label (loc/tr :lp-report-composer/edit-text))]
             [rich-text-editor/rich-text-editor
              {:read-only? true
               :border?    edit-mode?} editor-state]])]]))))

(defn rich-text-content
  [{:keys [html-content completed-at _complete-changed! show-draft? edit-text-label _can-edit?
           _on-change background-color?
           toolbar]}]
  (let [local-state (r/atom {:draft? (cu/blank-value? completed-at)
                             :current-content html-content})]
    (fn [{:keys [_html-content completed-at complete-changed! can-edit? on-change]}]
      (let [edit-mode? (:edit-mode? @local-state)
            current-content (:current-content @local-state)
            local-draft? (:draft? @local-state)
            draft? (if (boolean? local-draft?)
                     local-draft?
                     (cu/blank-value? completed-at))
            toolbar-options (or toolbar tiptap/no-align-toolbar-options)]

        [:div
         {:class (h/<class (partial style/text-container (and draft? show-draft?) background-color?))}

         (when (and draft? show-draft?)
           [:div
            {:class (h/<class style/draft-indicator)}
            (loc/tr :draft)])

         [:div
          (cond
            ;; Read-only mode (no edit permission)
            (not can-edit?)
            [tiptap/viewer
             {:value current-content
              :class (when edit-mode? "border border-solid border-gray-300 rounded")}]

            ;; Edit mode
            edit-mode?
            [:div
             [tiptap/editor
              (merge toolbar-options
                     {:value current-content
                      :on-change #(swap! local-state assoc :current-content %)
                      :class "mb-4"})]
             [button/primary-solid
              {:on-click (fn [_e]
                           (on-change current-content)
                           (swap! local-state dissoc :edit-mode?))}
              (loc/tr :save)]
             [:label
              {:class (h/<class style/complete-label)}
              [:input
               {:type "checkbox"
                :checked (not draft?)
                :on-change (fn [_i]
                             (swap! local-state assoc :draft? (not draft?))
                             (complete-changed! current-content (not draft?))
                             (when draft?
                               (swap! local-state dissoc :edit-mode?)))}]
              [:span
               {:class (h/<class style/complete-label-text)}
               (loc/tr :lp-editor-text-complete-label)]]]

            ;; View mode (can edit, but not currently editing)
            :else
            [:div
             [:span
              {:class (<class style/edit-text)
               :on-click (fn [e]
                           (fu/stop-propagation-event! e)
                           (swap! local-state assoc :edit-mode? true))}
              (or edit-text-label (loc/tr :lp-report-composer/edit-text))]
             [tiptap/viewer
              {:value current-content
               :class (when edit-mode? "border border-solid border-gray-300 rounded")}]])]]))))

(def footnote-toolbar
  {:show-alignment? false
   :show-block-type? false
   :link? false
   :inline-options [:bold :italic :underline]})

(defn optional-footnote
  [{:keys [rich-content rich-content-path
           rich-content-completed-at rich-content-completed-path]}
   {:keys [edit-mode? show-draft? edit-mode-footer? save-text save-image-with-text image-with-footnote?]}]
  (let [save-fn (if image-with-footnote? 
                  save-image-with-text 
                  save-text)]
    (when (or edit-mode?
              edit-mode-footer?
              (not (tiptap/empty-editor-value? rich-content)))
      [grid/row {}
       [grid/column {}
        [rich-text-content
         {:html-content      rich-content
          :completed-at      rich-content-completed-at
          :complete-changed! (when (and edit-mode?
                                        (fn? save-fn))
                               (fn [new-content completed?]
                                 (save-fn rich-content-path
                                          new-content
                                          rich-content-completed-path
                                          (if completed?
                                            ""
                                            (str (c-time/now-millis))))))
          :toolbar           footnote-toolbar
          :show-draft?       show-draft?
          :can-edit?         (or edit-mode? edit-mode-footer?)
          :edit-text-label   (loc/tr :lp-report-composer/edit-footnote)
          :on-change         (when (and (or edit-mode? edit-mode-footer?)
                                        (fn? save-fn))
                               (fn [new-content]
                                 (println "SAVE TEXT CHANGED!")
                                 (save-fn rich-content-path new-content)))
          :background-color? true}]]])))
